import { render } from "./IconArrownDown.vue?vue&type=template&id=81c8544a&ts=true"
import script from "./IconArrownDown.vue?vue&type=script&lang=ts"
export * from "./IconArrownDown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__